import { Link } from "react-router-dom";

import {
  Eyebrow,
  PartnersComingBand,
  PublicShell,
} from "../components/PublicShell";
import { useT } from "../i18n/LanguageProvider";
import { useIsMobile } from "../hooks/useIsMobile";
import { C } from "../styles/tokens";

export function ForBusinessesPage() {
  const t = useT();
  const isMobile = useIsMobile();
  return (
    <PublicShell>
      {/* Content + corporate photo */}
      <section
        style={{
          background: `linear-gradient(180deg, ${C.surface} 0%, #fff 100%)`,
          padding: isMobile ? "40px 20px 48px" : "64px 40px 80px",
        }}
      >
        <div
          style={{
            maxWidth: 1120,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1.15fr 1fr",
            gap: isMobile ? 32 : 56,
            alignItems: "center",
          }}
        >
          <div>
            <Eyebrow>{t("landing.bizEyebrow")}</Eyebrow>
            <h1
              style={{
                fontSize: isMobile ? 30 : 40,
                fontWeight: 800,
                color: C.navy,
                letterSpacing: -0.8,
                lineHeight: 1.15,
                margin: "0 0 18px",
              }}
            >
              {t("landing.bizHeadline")}
            </h1>
            <p style={bodyPara}>{t("landing.bizBody1")}</p>
            <p style={bodyPara}>{t("landing.bizBody2")}</p>
            <p style={{ ...bodyPara, marginBottom: 26 }}>
              {t("landing.bizBody3")}
            </p>
            <Link
              to="/register/organisation"
              style={{
                display: "inline-block",
                padding: "13px 26px",
                fontSize: 15,
                fontWeight: 700,
                color: "#fff",
                background: C.navy,
                borderRadius: 6,
                textDecoration: "none",
              }}
            >
              {t("landing.ctaOrgBtn")}
            </Link>
          </div>
          <img
            src="/biz-corporate.jpg"
            alt="Corporate office buildings"
            style={{
              width: "100%",
              borderRadius: 16,
              boxShadow: "0 24px 60px -24px rgba(22,41,76,0.45)",
              objectFit: "cover",
              aspectRatio: "4 / 3",
            }}
          />
        </div>
      </section>

      {/* Partner strip -- names appear here once companies are onboarded */}
      <PartnersComingBand title={t("pub.bizMarqueeTitle")} />

      {/* Small closing CTA */}
      <section
        style={{
          padding: isMobile ? "44px 20px" : "56px 40px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            margin: "0 auto 22px",
            maxWidth: 640,
            fontSize: isMobile ? 22 : 28,
            fontWeight: 800,
            color: C.navy,
            letterSpacing: -0.4,
            lineHeight: 1.25,
          }}
        >
          {t("landing.bottomCtaTitle")}
        </h2>
        <Link
          to="/register/organisation"
          style={{
            display: "inline-block",
            padding: "13px 28px",
            fontSize: 15,
            fontWeight: 700,
            color: "#fff",
            background: C.primary,
            borderRadius: 6,
            textDecoration: "none",
          }}
        >
          {t("landing.ctaOrgBtn")}
        </Link>
      </section>
    </PublicShell>
  );
}

const bodyPara = {
  fontSize: 15.5,
  color: C.textMed,
  lineHeight: 1.7,
  margin: "0 0 14px",
};
